import { State } from '../stores/global';

const localStorage = window.localStorage;
const USER_KEY = 'bimmotrade_user';
const VERSION_KEY = 'bimmotrade_version';

export function setVersion(version: number) {
  window.localStorage.setItem(VERSION_KEY, JSON.stringify(version));
}

export function getVersion() {
  try {
    return JSON.parse(localStorage.getItem(VERSION_KEY)!) as number;
  } catch (err) {
    return 0;
  }
}

export function getUser() {
  try {
    const user = JSON.parse(localStorage.getItem(USER_KEY)!);
    return user?.token ? (user as State['user']) : undefined;
  } catch (err) {
    return undefined;
  }
}

export function setUser(data: any) {
  window.localStorage.setItem(USER_KEY, JSON.stringify(data));
}

export function removeUser() {
  window.localStorage.removeItem(USER_KEY);
}
